import { useEffect, useContext, useState } from "react";
import axios from "axios";
import classes from "../Pages.module.css";
import { Skeleton, Row, Col, message, Tooltip, Modal, Button } from "antd";
// import { Form, Input } from "antd";
import { AiFillDelete } from "react-icons/ai";
import { FaPenAlt } from "react-icons/fa";
import DataContext from "../../../Context/dataContext";
import EmployeeTable from "../EmployeeTable/EmployeeTable";
import FormRenderer from "./FormRenderer";
import { Link } from "react-router-dom";
// import { useParams } from "react-router-dom";
import { notification } from "antd";
import {  getFormPermissions } from '../../../utils/checkDayPermission';

const Misc = (props) => {
  console.log(props.data, "uom");
  // const { id1 } = useParams();
  const employeeData = useContext(DataContext);
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  // const [title, setTitle] = useState("");
  const [rows, setRows] = useState(null);
  const [form, setForm] = useState(null);
  const [urows, setURows] = useState(true);
  const [vrows, setVRows] = useState(true);
  const [uform, setUForm] = useState(null);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [id, setID] = useState("");
  // const [identifier, setIdentifier] = useState("");
  const [allData, setAllData] = useState({
    cityHeader: [
      {
        city_name: null,
        state_code: null,
        distt: null,
        country_code: null,
      },
    ],
  });
  const [allData1, setAllData1] = useState({
    cityHeader: [
      {
        city_name: null,
        state_code: null,
        distt: null,
        country_code: null,
      },
    ],
  });
  // const [mata, setMata] = useState({
  //   cityHeader: [
  //     {
  //       city_name: null,
  //       state_code: null,
  //       distt: null,
  //       country_code: null,
  //     },
  //   ],
  // });
  const [ad, setAD] = useState(null);

  const { canAdd, canModify, canDelete, canQuery, messages } = getFormPermissions("City Master", employeeData);
  // Get permission flags for the current form including day-based checks
  
  useEffect(() => {
   
    setForm((form) => {
      const newForm = null;
      return newForm;
    });
    setID("");
   
    setRows(null);
    setColumns([]);
    setLoading(false);
    setAD(null);

    axios
      .get(employeeData.URL + "/api/v1/city/", {
        withCredentials: true,
      })
      .then((response) => {
        console.log(response);
        console.log(response.data.data.city);


        setColumns((columns) => {
          let newCols = response.data.data.city.fields.map((col) => {
            return {
              name: col.name,
              title: col.name.split("_").join(" ").toLowerCase(),
            };
          });

          const newNewCols = [
            { name: "V", title: "V" },
            { name: "D", title: "D" },
            { name: "SNO", title: "SNo" },
            ...newCols,
          ];
          return newNewCols;
        });

        setRows((rows) => {
          let newRows = response.data.data.city.rows.map((row, index) => {
            return {
              V: (() => {
               
                return canModify ? (
                <Tooltip placement="bottom" title="Edit" color="#1777C4">
                  <Link
                    to="#"
                    style={{ color: "#1777C4", fontWeight: "bolder" }}
                    onClick={(event) =>
                      editHandler(
                        event,
                        index,
                        // response.data.data.tableHeader.row_identifier,
                        row["city_code"],
                        response.data.data.city.rows
                      )
                    }
                  >
                    <FaPenAlt
                      style={{ color: "#1777C4", fontWeight: "bolder" }}
                    />
                  </Link>
                </Tooltip>
              ):(
                <Tooltip placement="bottom" title={messages.modify} color="#1777C4">
                    <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                      <FaPenAlt
                        style={{ color: "#1777C4", fontWeight: "bolder" }}
                      />
                    </span>
                  </Tooltip>
              );
            })(),
              D: (() => {
                
                return canDelete ? (
                <Tooltip placement="bottom" title="Delete" color="red">
                  <Link
                    to="#"
                    style={{ color: "red", fontWeight: "bolder" }}
                    onClick={(event) =>
                      deleteHandler(
                        event,
                        index,
                        response.data.data.city.rows,
                        row["city_code"]
                      )
                    }
                  >
                    <AiFillDelete
                      style={{ color: "red", fontWeight: "bolder" }}
                    />
                  </Link>
                </Tooltip>
              ):(
                <Tooltip placement="bottom" title={messages.delete} color="red">
                <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                  <AiFillDelete
                    style={{ color: "red", fontWeight: "bolder" }}
                  />
                </span>
              </Tooltip>
              );})(),
              SNO: index + 1,
              ...row,
            };
          });

          return newRows;
        });

        
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(employeeData.URL + "/api/v1/city/additional-data", {
        withCredentials: true,
      })
      .then((response) => {
        console.log(response);
        setAD((ad) => {
          let newad = response.data.data;
          return {
            ...newad,
          };
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }, [employeeData, canDelete, canQuery]);

  const deleteHandler = (event, index, newrows, code) => {
   
    if (!canDelete) {
      return;
    }
    console.log(code,"city_code");
    console.log(newrows,"newRows_ils tkjcf");
    setLoading(true);
    setRows(null);
  
    axios
      .delete(employeeData.URL + "/api/v1/city/" + code.toString(), {
        withCredentials: true,
      })
      .then((response) => {
        const { message: backendMessage, isUsed } = response.data;
  
        if (response.data.status === "success") {
          message.success(backendMessage);
        } else {
          message.warning(backendMessage);
        }
  
        let rowvals = newrows;
        if (!isUsed) {
          rowvals = newrows.filter((row) => row["city_code"] !== code);
        }
  
        setRows((rows) => {
          let newDRows = rowvals.map((row, index) => {
            return {
              V: (
                <Tooltip placement="bottom" title="Edit" color="#1777C4">
                  <Link
                    to="#"
                    style={{ color: "#1777C4", fontWeight: "bolder" }}
                    onClick={(event) =>
                      editHandler(event, index, row["city_code"])
                    }
                  >
                    <FaPenAlt
                      style={{
                        color: "#1777C4",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ),
              D: (
                <Tooltip placement="bottom" title="Delete" color="red">
                  <Link to="#" style={{ color: "red", fontWeight: "bolder" }}>
                    <AiFillDelete
                      onClick={(event) =>
                        deleteHandler(event, index, rowvals, row["city_code"])
                      }
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ),
              SNO: index + 1,
              ...row,
            };
          });
          return newDRows;
        });
        setLoading(false);
      })
      .catch((error) => {
        message.error("Failed to delete city. Please try again.");
        setRows((rows) => {
          let newDRows = newrows.map((row, index) => {
            return {
              V: (
                <Tooltip placement="bottom" title="Edit" color="#1777C4">
                  <Link
                    to="#"
                    style={{ color: "#1777C4", fontWeight: "bolder" }}
                    onClick={(event) =>
                      editHandler(event, index, row["city_code"])
                    }
                  >
                    <FaPenAlt
                      style={{
                        color: "#1777C4",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ),
              D: (
                <Tooltip placement="bottom" title="Delete" color="red">
                  <Link to="#" style={{ color: "red", fontWeight: "bolder" }}>
                    <AiFillDelete
                      onClick={(event) =>
                        deleteHandler(event, index, newrows, row["city_code"])
                      }
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ),
              SNO: index + 1,
              ...row,
            };
          });
          return newDRows;
        });
        setLoading(false);
      });
  };
  

  const editHandler = (event, mainindex, code, newRows) => {
    
    if (!canModify) {
      return;
    }
    console.log("vandna",newRows);
    console.log("Edit button clicked");
    console.log(newRows, "kdkdkdkdkdkdkkd");
    setVRows(false);
    const rowData = newRows[mainindex];
    console.log(rowData,"this is row data in edit handler");
  

    const transformedData = {
      cityHeader: [
        {
          city_name: rowData.city_name,
          state_code: rowData.state_name,
          distt: rowData.distt,
          country_code: rowData.country_name,
        },
      ],
    };

    setAllData1(transformedData);
    setID(code);
    setVisible(true);
  };

  const validateAllData = (allData) => {
    const cityHeaderData = allData.cityHeader[0];
    let formValid = true;

    // Check if any of the required fields in cityHeaderData are null or empty
    if (
      !cityHeaderData.city_name ||
      !cityHeaderData.state_code ||
      !cityHeaderData.distt ||
      !cityHeaderData.country_code
    ) {
      notification.error({
        message: "Missing Required Fields",
        description:
          "Please fill in all the required fields in the city header.",
        duration: 5,
      });
      formValid = false;
    }

    return formValid;
  };

  const handleSubmit = (event) => {
    console.log(allData);
    const postData = {
      ...allData,
    };

    event.preventDefault(); // Prevent default form submission

    if (!validateAllData(allData)) {
      return;
    }

    console.log(postData);
    setLoading(true);
    axios
      .post(employeeData.URL + "/api/v1/city/create-city", postData, {
        withCredentials: true,
        credentials: "include",
      })
      .then((response) => {
        console.log(response);
        // Check the response for success
        if (response.data.status === "success") {
          // Display success message
          message.success({
            content: "Record Added Successfully!!!!",
            className: "custom-class",
            style: {
              marginTop: "20vh",
            },
          });
        } else {
          // Display error message for duplicate data
          message.error({
            content: response.data.message || "Error adding record.",
            className: "custom-class",
            style: {
              marginTop: "20vh",
            },
          });
        }

        setRows(null);
        setLoading(false);

        setAllData((prevData) => ({
          ...prevData,
          cityHeader: [
            { city_name: "", state_code: "", distt: "", country_code: "" },
          ],
        }));

        axios
          .get(employeeData.URL + "/api/v1/city/", {
            withCredentials: true,
          })
          .then((response) => {
            console.log(response.data.data.city);
            setRows((rows) => {
              let newRows = response.data.data.city.rows.map((row, index) => {
                return {
                  V: (() => {
                    
                    return canModify ? (
                    <Tooltip placement="bottom" title="Edit" color="#1777C4">
                      <Link
                        to="#"
                        style={{ color: "#1777C4", fontWeight: "bolder" }}
                        onClick={(event) =>
                          editHandler(
                            event,
                            index,
                            //   response.data.data.tableHeader.row_identifier,
                            row["city_code"],
                            response.data.data.city.rows
                            //   response.data.data.tableHeader.master_fields
                          )
                        }
                      >
                        <FaPenAlt
                          style={{ color: "#1777C4", fontWeight: "bolder" }}
                        />
                      </Link>
                    </Tooltip>
                  ):(
                    <Tooltip placement="bottom" title={messages.modify} color="#1777C4">
                          <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                            <FaPenAlt
                              style={{ color: "#1777C4", fontWeight: "bolder" }}
                            />
                          </span>
                        </Tooltip>
                  );
                })(),
                  D: (() => {
                   
                    return canDelete ? (
                    <Tooltip placement="bottom" title="Delete" color="red">
                      <Link
                        to="#"
                        style={{ color: "red", fontWeight: "bolder" }}
                        onClick={(event) =>
                          deleteHandler(
                            event,
                            //   response.data.data.tableHeader.row_identifier,
                            row["city_code"]
                          )
                        }
                      >
                        <AiFillDelete
                          style={{ color: "red", fontWeight: "bolder" }}
                        />
                      </Link>
                    </Tooltip>
                  ):(
                    <Tooltip placement="bottom" title={messages.delete} color="red">
                          <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                            <AiFillDelete
                              style={{ color: "red", fontWeight: "bolder" }}
                            />
                          </span>
                        </Tooltip>
                  );
                })(),
                  SNO: index + 1,
                  ...row,
                };
              });
              return newRows;
            });
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        setLoading(false);

        message.error({
          content: "please fill all feild!!!!",
          className: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
      });
  };

  const handleOk = () => {
    // setConfirmLoading(true);
    console.log(allData1);
    const postData = {
      ...allData1,
    };

    console.log(postData);

    axios
      .patch(employeeData.URL + "/api/v1/city/" + id.toString(), postData, {
        withCredentials: true,
        credentials: "include",
      })
      .then((response) => {
        console.log(response);
        setConfirmLoading(false);
        setVisible(false);

        message.success({
          content: "Record update Successfully!!!!",
          className: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        setRows(null);
        setLoading(false);
        setID("");
     

        // setAllData1({
        //   ...allData1,
        //   uomHeader: [{ uom: (element.value = "") }],
        // });
        // setForm((form) => {
        //   const newForm = [...form];
        //   newForm.forEach((element) => (element.value = ""));

        //   return newForm;
        // });

        axios
          .get(employeeData.URL + "/api/v1/city/", {
            withCredentials: true,
          })
          .then((response) => {
            setRows((rows) => {
              let newRows = response.data.data.city.rows.map((row, index) => {
                return {
                  V: (
                    <Tooltip placement="bottom" title="Edit" >
                      <Link
                        to="#"
                        style={{ color: "#1777C4" }}
                        onClick={(event) =>
                          editHandler(
                            event,
                            index,
                            //   response.data.data.tableHeader.row_identifier,
                            row["city_code"],
                            response.data.data.city.rows
                          )
                        }
                      >
                        <FaPenAlt
                          // style={{ color: "#1777C4", fontWeight: "bolder" }}
                        />
                      </Link>
                    </Tooltip>
                  ),
                  D: (
                    <Tooltip placement="bottom" title="Delete" color="red">
                      <Link
                        to="#"
                        style={{ color: "red", fontWeight: "bolder" }}
                        onClick={(event) =>
                          deleteHandler(
                            event,
                            //   response.data.data.tableHeader.row_identifier,
                            row["city_code"]
                          )
                        }
                      >
                        <AiFillDelete
                          style={{ color: "red", fontWeight: "bolder" }}
                        />
                      </Link>
                    </Tooltip>
                  ),
                  SNO: index + 1,
                  ...row,
                };
              });
              return newRows;
            });
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        setLoading(false);
        setConfirmLoading(false);
        message.error({
          content: "Some Error Occurred!!!!",
          className: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
      });
  };

  const handleCancel = () => {
    
   
    setVisible(false);
    setConfirmLoading(false);
    axios
      .get(employeeData.URL + "/api/v1/city/", {
        withCredentials: true,
      })
      .then((response) => {
        setLoading(false);

        // let inputTypes = response.data.data.tableHeader.input_type.split(", ");

        let newRows = response.data.data.city.rows.map((row, index) => {
          return {
            V: (
              <Tooltip placement="bottom" title="Edit" >
                <Link
                  to="#"
                  style={{ color: "#1777C4", fontWeight: "bolder" }}
                  onClick={(event) =>{
                    
                   if(canModify){
                    editHandler(
                      event,
                      index,

                      row["city_code"],
                      response.data.data.uom.rows
                    );
                  }
                }}
                >
                  <FaPenAlt
                    style={{ color: "#1777C4", fontWeight: "bolder" }}
                  />
                </Link>
              </Tooltip>
            ),
            D: (
              <Tooltip placement="bottom" title="Delete" color="red">
                <Link
                  to="#"
                  style={{ color: "red", fontWeight: "bolder" }}
                  onClick={(event) =>{
                   
                    if (canDelete) {
                    deleteHandler(
                      event,

                      row["city_code"]
                    );
                  }
                }}
                >
                  <AiFillDelete
                    style={{ color: "red", fontWeight: "bolder" }}
                  />
                </Link>
              </Tooltip>
            ),
            SNO: index + 1,
            ...row,
          };
        });
        setRows(newRows);
        setLoading(false);
      });

    // setAllData1({
    //   ...allData1,
    //   uomHeader: [{ uom: (element.value = "") }],
    // });
  };

  return (
    <>
      <Modal
        title="Edit Record"
        visible={visible}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={confirmLoading}
            onClick={handleOk}
          >
            Submit
          </Button>,
        ]}
      >
        {/* <Form
          onFinish={handleOk}
          //   initialValues={{ uom: allData.uomHeader[0].uom }} // Set initial value for uom field
          defaultValue=""
        >
          <Form.Item
            label="Unit Of Measurement"
            name="uom"
            // rules={[
            //   { required: true, message: "Please enter Measure Of Unit!" },
            // ]}
          >
            <Input
              placeholder="Enter Measure Of Unit"
              onChange={(e) => {
                setMata((prevData) => ({
                  ...prevData,
                  uomHeader: [{ uom: e.target.value }],
                }));
              }}
            />
          </Form.Item>
        </Form> */}
        {ad ? (
          <FormRenderer
            loading={loading}
            form={uform}
            setForm={setUForm}
            handleSubmit={handleOk}
            save={false}
            setData={setAllData1}
            data={allData1.cityHeader[0]}
            setURows={setURows}
            urows={urows}
            vrows={vrows}
            ad={ad}
          />
        ) : (
          <p>Loading...</p> // Or any other fallback UI
        )}
      </Modal>
      <Row className={classes["Row"]}>
        <Col md={14}>
          <p className={classes["Title"]}>City Master</p>
        </Col>
        <Col className={classes["Col"]} md={10}></Col>
      </Row>
      <p></p>

      {ad && canAdd ? (
        <FormRenderer
          loading={loading}
          form={form}
          setForm={setForm}
          handleSubmit={handleSubmit}
          save={true}
          setData={setAllData}
          data={allData.cityHeader[0]}
          urows={urows}
          vrows={vrows}
          ad={ad}
        />
      ) : (
        <p>{!ad ? "Loading..." : "You don't have permission to add records"}</p>
      )}
      <hr></hr>
      <p></p>
      {rows && columns.length > 0 ? (
        <EmployeeTable
          val={false}
          data={rows}
          columns={columns}
          deleteHandler={deleteHandler}
        />
      ) : (
        <>
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
        </>
      )}
    </>
  );
};

export default Misc;
